import { PropsWithChildren } from "react";
import { LegislationFilterConfigProvider as FilterConfigProvider } from "./LegislationFilterConfigContext";
import { LegislationTableFilterProvider } from "./LegislationTableFilterContext";
import { TenantSearchFilterProvider } from "./TenantSearchFilterContext";

const LegislationFilterConfigProvider = ({ children }: PropsWithChildren) => {
  return (
    <FilterConfigProvider>
      <LegislationTableFilterProvider>
        <TenantSearchFilterProvider>{children}</TenantSearchFilterProvider>
      </LegislationTableFilterProvider>
    </FilterConfigProvider>
  );
};

export default LegislationFilterConfigProvider;
